import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * Subscription Actions
 */
export default generateWithAsyncActions(alt, [
    'getStatus',
    'subscribe',
    'getOptOutLink']);
